export enum TranslationsEn {
  YEAR_MONTH_DAY = '{year}-{month}-{day}',
  MON = 'Mon',
  TUE = 'Tue',
  WED = 'Wed',
  THU = 'Thu',
  FRI = 'Fri',
  SAT = 'Sat',
  SUN = 'Sun',
  STREET_ADDRESS1 = 'Address 1',
  STREET_ADDRESS2 = 'Address 2',
  CITY = 'City',
  STATE = 'State',
  ZIP_CODE = 'Zip',
  COUNTRY = 'Country',
  OK = 'Ok',
  CANCEL = 'Cancel',
  CONFIRMATION = 'Confirmation',
  ARE_YOU_SURE_YOU_WANT_TO_CANCEL = 'Are you sure you want to cancel?',
  STEP = 'Step',
  OF = 'of',
  PREVIOUS = 'Previous',
  NEXT = 'Next',
  SAVE = 'Save',
  SAVE_AND_NEXT = 'Save and Next',
  SUBMIT = 'Submit',
  CLOSE = 'Close',
  ENLARGED_ATTACHMENT = 'Enlarged attachment',
  NO_INFO = 'No information',
  BEDROOMS = 'Bedrooms',
  BATHROOMS = 'Bathrooms',
  HOME = 'Home',
  PROGRESS = 'Progress',
  START_DATE = 'Start date',
  END_DATE = 'End date',
  UNKNOWN = 'Unknown',
  VIEW_ALL = 'View all',
  FEET = 'ft',
  SUCCESS = 'Success!',
  FINISH = 'Finish',
  SOMETHING_WENT_WRONG = 'Oops! Something went wrong!',
  EMAIL = 'Email',
  UPLOAD_FILE = 'Upload file',
  OPEN_FILE = 'Open file',
  BACK = 'Back',
  TENANT_SIGN_IN = 'Tenant portal',
  NO_RENTAL_HISTORY_ERROR = 'Please enter details for at least one prior rental.',
  CANNOT_PERFORM_SCREENING = 'Screening cannot be performed right now.',
  CANNOT_MAKE_PAYMENTS = 'Payments are not available right now.',
  STRIPE_COULD_NOT_BE_REACHED = 'Stripe could not be reached. Please try again in a moment',
  PAYMENT_DECLINED = 'Your payment was declined. Please use a different card or payment method.',
  VIEW_SPECIFIC_REASON = 'View specific reason',
  PAYMENT_FAILED = 'Your payment did not go through. Please try again.',
  PAYMENT_DECLINE_UNKNOWN = "We couldn't complete this transaction. Contact support for assistance.",
  PAYMENT_DECLINE_INVALID_REQUEST = "The payment request couldn't be accepted as provided. Contact support for assistance.",
  PAYMENT_DECLINE_INVALID_AMOUNT = "The transaction amount isn't valid. Review the amount or contact support.",
  PAYMENT_DECLINE_INVALID_VALUE = "One or more submitted values couldn't be accepted. Review the details or contact support.",
  PAYMENT_DECLINE_UNAUTHORIZED = 'The payment request was refused because the credentials were not accepted. Contact support for assistance.',
  PAYMENT_DECLINE_FORBIDDEN = "This payment isn't permitted. Contact support for assistance.",
  PAYMENT_DECLINE_DUPLICATE_REQUEST = 'This request matches an earlier one. Verify the existing record before sending another payment.',
  PAYMENT_DECLINE_TIMEOUT = "The payment provider didn't answer in time. Contact support for assistance.",
  PAYMENT_DECLINE_PROVIDER_UNAVAILABLE = 'The payment provider is temporarily unavailable. Contact support to confirm the transaction outcome.',
  PAYMENT_DECLINE_PROVIDER_ERROR = "We couldn't complete this transaction. Contact support for assistance.",
  PAYMENT_DECLINE_PROCESSING_LIMIT_EXCEEDED = 'This transaction exceeds the applicable payment processing limit. Contact support to confirm the permitted limits.',
  PAYMENT_DECLINE_PAYMENT_METHOD_LIMIT_EXCEEDED = 'This transaction exceeds a limit on this payment method. Contact the account holder to confirm the applicable limits.',
  PAYMENT_DECLINE_PAYMENT_METHOD_VERIFICATION_FAILED = "We couldn't verify this payment method. Use another payment method or contact support.",
  PAYMENT_DECLINE_PAYMENT_METHOD_HOLDER_MISMATCH = "The account holder details couldn't be matched. Check the details registered with your bank or use another payment method.",
  PAYMENT_DECLINE_COLLECT_DECLINED = "Your bank didn't approve this payment. Contact your bank or use another payment method.",
  PAYMENT_DECLINE_COLLECT_INSUFFICIENT_FUNDS = "The payment couldn't be completed because of insufficient funds or an exceeded credit limit. Contact the account holder or use another payment method.",
  PAYMENT_DECLINE_COLLECT_METHOD_INVALID = "This payment method can't be used. Review the details or use another payment method.",
  PAYMENT_DECLINE_COLLECT_METHOD_EXPIRED = 'This payment method has expired. Use another payment method.',
  PAYMENT_DECLINE_COLLECT_RESTRICTED = "This payment isn't permitted for this payment method. Contact your bank or use another payment method.",
  PAYMENT_DECLINE_COLLECT_REQUIRES_ACTION = 'Additional action is needed to complete this payment. Contact support for assistance.',
  PAYMENT_DECLINE_KYC_REQUIRED = "This transaction couldn't be approved. Contact support for assistance.",
  PAYMENT_DECLINE_KYC_FAILED = "This transaction couldn't be approved. Contact support for assistance.",
  PAYMENT_DECLINE_RISK_REJECTED = "This transaction couldn't be approved. Contact support for assistance.",
  PAYMENT_DECLINE_SANCTION_RESTRICTED = "This transaction couldn't be approved. Contact support for assistance.",
  PAYMENT_DECLINE_INTERNAL_ERROR = "We couldn't complete this transaction. Contact support for assistance.",
  BUSINESS_INFO_NOT_FOUND = 'Business information is missing.',
  RENTAL_APPLICATION_NOT_FOUND = 'We could not find this rental application.',
  FILE_UPLOAD_FAILED = 'File upload failed. Please try again.',
  FILE_NOT_ACCEPTED = "One of your files can't be uploaded because of its type or size. Please remove it and try again.",
  FILE = 'File',
  LEASE_INSURANCE_MISSING_FIELDS = 'Required information is missing. Please fill in all fields and try again.',
  LEASE_OR_SIGNATURE_NOT_FOUND = 'This lease or signature could not be found.',
  FILE_SESSION_RESPONSE_INVALID = 'We could not start the file upload. Please try again.',
  REMOVE = 'Remove',
  APPLICANT_INFORMATION = 'Applicant information',
  GET_STARTED = 'Your details',
  POTENTIAL_UNITS = 'Potential units',
  UNITS_OF_INTEREST = 'Units of interest',
  ALL_UNITS = 'All units',
  OPEN_TO_ALL_UNITS = 'Open to all units',
  RENTAL_HISTORY = 'Rental history',
  WORK_HISTORY = 'Work history and income verification',
  TERM_AND_CONDITIONS = 'Terms and conditions',
  CONFIRM_YOUR_IDENTITY = 'Confirm your identity',
  PETS_AND_CARS = 'Pets and cars',
  QUESTIONS = 'Questions',
  RENTAL_APPLICATION = 'Rental application',
  SUBMIT_A_RENTAL_APPLICATION = 'Submit a rental application',
  MAGICDOOR_TERMS = 'MagicDoor Terms and Conditions',
  TRANS_UNION_TERMS = 'TransUnion Terms and Conditions',
  ADD_RENTAL_HISTORY = 'Add rental history',
  REASON_FOR_LEAVING = 'Reason for leaving',
  LANDLORD_NAME = 'Landlord name',
  LANDLORD_PHONE = 'Landlord phone',
  RENT = 'Rent',
  MOVE_IN_DATE = 'Move-in date',
  MOVE_OUT_DATE = 'Move-out date',
  I_HAVE_READ_AND_AGREED_TO_THE_TERMS = 'I have read and agreed to the terms of service',
  ADD_EMPLOYMENT = 'Add employment',
  EMPLOYMENT_HISTORY = 'Employment history',
  I_AM_EMPLOYED = 'I am currently employed',
  ANNUAL_INCOME = 'Annual income',
  NAME = 'Name',
  PHONE = 'Phone',
  POSITION = 'Position',
  JOB_TITLE = 'Job title',
  SALARY = 'Salary',
  START_SCREENING = 'Start screening',
  PAYMENT_DETAILS = 'Payment details',
  SUBMIT_ANSWERS = 'Submit answers',
  PAYMENT_PROCESSING = 'Payment processing ...',
  PAYMENT_PROCESSING_BLURB = "Your transaction is being processed. This may take a couple of minutes. Please sit tight and don't close your screen",
  DONE = 'Done',
  SUBMITTED = 'Submitted',
  RENTAL_APPLICATION_SUCCESSFULLY_SUBMITTED = 'Congratulations — your application is now submitted!',
  RENTAL_APPLICATION_NOTIFICATION = 'We will get back to you as soon as possible.',
  CONNECTING_TO_TRANS_UNION = 'Connecting to TransUnion to Prepare Questionnaire and Initiate ID Verification ...',
  CONNECTING_TO_TRANS_UNION_BLURB = "Please hold on tight and don't leave this page - we're securely fetching your questionnaire and setting up ID verification.",
  CONTACT_CUSTOMER_SUPPORT = 'For completing your screening process, please contact our customer support at ',
  CONTACT_CUSTOMER_SUPPORT_BLURB = 'While on the call, please remain on this screen for real-time updates. Once your call is complete, please stay on the page for next step.',
  UNABLE_TO_VERIFY_IDENTITY = 'We are unable to verify your identity online.',
  RENTER_SCREENING_ID = 'Renter screening ID= {renterID}',
  PAGE_NOT_FOUND = 'Page Not Found',
  PAGE_NOT_FOUND_BLURB_1 = 'Looks like you found the doorway to the great nothing, sorry about that.',
  PAGE_NOT_FOUND_BLURB_2 = 'Please visit our hompage to get where you need to go.',
  COMPANY_NOT_FOUND = "It looks like the page you're looking for doesn't exist. Please check the URL or contact your property manager for assistance.",
  FIRST_NAME = 'First name',
  LAST_NAME = 'Last name',
  SSN = 'SSN',
  DATE_OF_BIRTH = 'Date of birth',
  VIEW_IN_FULL_SCREEN = 'Open in new tab',
  WELCOME = 'Welcome',
  YOU_HAVE_TO_ACCEPT_THIS_LICENSE_AGREEMENT = 'You have to accept this license agreement',
  PAY = 'Pay',
  RENTAL_APPLICATION_FEE_BLURB = 'You are required to pay a non-refundable fee of {amount} to submit your application, that will go towards the screening costs.',
  TEXT_ONLY = 'Text only',
  LEASING = 'Leasing',
  CONFIRM = 'Confirm',
  END_DATE_IS_INVALID = 'End date is not valid',
  FIRST_NAME_IS_INVALID = 'First name is not valid',
  LAST_NAME_IS_INVALID = 'Last name is not valid',
  EMAIL_IS_INVALID = 'Email is not valid',
  PHONE_NUMBER_IS_INVALID = 'Phone number is not valid',
  DATE_OF_BIRTH_IS_INVALID = 'Date of birth is not valid',
  DATE_OF_BIRTH_IS_GREATER = 'Age cannot be greater than 125 years',
  DATE_OF_BIRTH_IS_LESSER = 'Age cannot be less than 18 years',
  ANNUAL_INCOME_IS_INVALID = 'Annual income is not valid',
  SSN_IS_INVALID = 'SSN is not valid',
  EMPLOYER_NAME_IS_INVALID = 'Employer name is not valid',
  SALARY_IS_INVALID = 'Salary is not valid',
  POSITION_TITLE_IS_INVALID = 'Position/title is not valid',
  START_DATE_IS_INVALID = 'Start date is not valid',
  END_DATE_IS_INVALID_EARLIER = 'End date cannot be earlier than start date',
  ADDRESS_IS_INVALID = 'Address is not valid',
  STREET_ADDRESS_1_IS_INVALID = 'Street address 1 is not valid',
  STREET_ADDRESS_2_IS_INVALID = 'Street address 2 is not valid',
  REASON_FOR_LEAVING_IS_INVALID = 'The length of the reason for leaving cannot exceed 500',
  CITY_IS_INVALID = 'City is not valid',
  STATE_IS_INVALID = 'State is not valid',
  ZIP_CODE_IS_REQUIRED = 'Zip code is required',
  ZIP_CODE_IS_INVALID = 'The U.S. zipcode must consist of 5 digits',
  COUNTRY_IS_INVALID = 'Country is not valid',
  LANDLORD_NAME_IS_INVALID = 'Landlord name is not valid',
  LANDLORD_PHONE_NUMBER_IS_INVALID = 'Landlord phone number is not valid',
  RENT_IS_INVALID = 'Rent is not valid',
  MOVE_IN_DATE_IS_INVALID = 'Move in date is not valid',
  MOVE_OUT_DATE_IS_INVALID = 'Move out date is not valid',
  MOVE_IN_DATE_IS_LATER = 'Move in date cannot be later than move out date',
  MOVE_OUT_DATE_IS_EARLIER = 'Move out date cannot be earlier than move in date',
  JOB_TITLE_IS_INVALID = 'Job title is not valid',
  FILE_IS_REQUIRED = 'File is required',
  COMPANY_NAME = 'Company name',
  FOLLOW_US = 'Follow us',
  PROPERTIES = 'Properties',
  CONTACT_US = 'Contact us',
  LET_US_GUIDE_YOU_HOME = 'Let us guide you home',
  BANNER_TITLE = "Discover a place you'll love to live",
  SEARCH = 'Search',
  PROPERTY_FOR_YOU_TITLE = 'Property for you',
  PROPERTY_FOR_YOU_SUBTITLE = "Search and save a few homes you like and we'll find recommendations for you.",
  PINNED = 'Pinned',
  PRICE = 'Price',
  MIN = 'Min',
  MAX = 'Max',
  NO_MIN = 'no min',
  NO_MAX = 'no max',
  HOME_TYPE = 'Home type',
  BEDS_AND_BATHS = 'Beds & Baths',
  ANY = 'Any',
  SINGLE_FAMILY = 'Single Family',
  MULTI_FAMILY = 'Multi Family',
  COMMERCIAL = 'Commercial',
  CONDO = 'Condo',
  TOWN_HOUSE = 'Town House',
  RESET = 'Reset',
  CONTACT_MANAGER = 'Contact manager',
  PET = 'Pet',
  PETS = 'Pets',
  AC = 'A/C',
  PARKING = 'Parking',
  UTILITIES_INCLUDED = 'Utilities included',
  INTERIOR_AMENITIES = 'Interior amenities',
  OUTDOOR_AMENITIES = 'Outdoor amenities',
  COMMUNITY_AMENITIES = 'Community amenities',
  OUTDOOR = 'Outdoor',
  LISTED = 'Listed',
  MONTH = 'Month',
  SQFT = 'sqft',
  OVERVIEW = 'Overview',
  HOME_HIGHLIGHTS = 'Home highlights',
  FACTS_AND_FEATURES = 'Facts and features',
  LOCAL_INFORMATION = 'Local information',
  SELECT_PRICE = 'Select price',
  SELECT_HOME_TYPE = 'Select home type',
  SELECT_MOVE_IN_DATE = 'Select move in date',
  SLIDE_UP_TO_LOAD_MORE = 'Slide up to load more',
  APPLY = 'Apply',
  PROPERTY_DETAIL = 'Property Detail',
  ZERO_RESULTS_DESC = 'No results found for the given address. Please check the address and try again.',
  MAP_ERROR_DESC = 'An error occurred while loading the map. Please try again later.',
  SEARCH_FOR_YOUR_DREAM_HOME = 'Search for your dream home',
  ALL_RIGHTS_RESERVED = 'All rights reserved',
  DBA_TENANT_FRIENDLY_NAME = '"{companyName}" is a tenant-friendly name operating as the following legal entities:',
  DBA_ALSO_OPERATES_AS = '"{companyName}" also operates as the following legal entities:',
  DBA_ENTITY_MAY_VARY = 'The responsible legal entity may vary depending on which building you are a tenant of or applying to.',
  WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABLE_UNITS = "We currently don't have any available units, but you are always welcome to submit a rental application to us",
  PRIVACY_POLICY = 'Privacy policy',
  ACCEPT_TERMS_AND_CONDITIONS_PROCEED = 'Please accept the terms and conditions to proceed.',
  TERMS_OF_SERVICE = 'Terms of service',
  EQUAL_HOUSING_OPPORTUNITY = 'Equal housing opportunity',
  FILTER = 'Filter',
  FILTERS = 'Filters',
  SIGN_HERE = 'Sign here!',
  ALLOWED = 'Allowed',
  MONTHLY_PET_FEES = 'Monthly pet fees',
  NO_LIMIT = 'No limit',
  PET_DEPOSIT = 'Pet deposit',
  SMALL_WEIGHT = 'Small (under 22.0462 pounds)',
  MEDIUM_WEIGHT = 'Medium (22.0462 - 55.1156 pounds)',
  LARGE_WEIGHT = 'Large (55.1156 - 110.2311 pounds)',
  CATS = 'Cats',
  DOGS = 'Dogs',
  OTHER = 'Other',
  FISH = 'Fish',
  BIRDS = 'Birds',
  REPTILES = 'Reptiles',
  OTHERS = 'Others',
  ALL_ALLOWED = 'All allowed',
  DESIRED_MOVE_IN_DATE_IS_INVALID = 'Desired move in date is not valid',
  DESIRED_MOVE_IN_DATE = 'Desired move in date',
  CURRENT_UNIT_IS_UNLISTED = 'The unit you are applying for is no longer listed.',
  PLEASE_ANSWER_THIS_QUESTION = 'Please answer this question',
  COMMENT_CANNOT_EXCEED = 'Comment must be less than 500 characters',
  YOU_CAN_ADD_A_COMMENT_TO_THE_MANAGER = 'You can add a comment to the manager',
  COMMENT = 'Comment',
  PET_NAME_IS_INVALID = 'Pet name is invalid',
  BREED_IS_INVALID = 'Breed is invalid',
  PET_WEIGHT_IS_INVALID = 'Pet weight is invalid',
  AGE_IS_INVALID = 'Age is invalid',
  GENDER_IS_INVALID = 'Gender is invalid',
  SPAY_NEUTER_STATUS_IS_INVALID = 'Spayed/Neutered status is invalid',
  SERVICE_ANIMAL_STATUS_IS_INVALID = 'Service animal status is invalid',
  EMOTIONAL_SUPPORT_ANIMAL_STATUS_IS_INVALID = 'Emotional support animal status is invalid',
  CAR_MAKE_IS_INVALID = 'Car make is invalid',
  MODEL_IS_INVALID = 'Model is invalid',
  YEAR_IS_INVALID = 'Year is invalid',
  LICENSE_PLATE_IS_INVALID = 'License plate is invalid',
  STATE_REGISTRATION_IS_INVALID = 'State registration is invalid',
  CAR_COLOR_IS_INVALID = 'Car color is invalid',
  YOU_HAVE_SUCCESSFULLY_SIGNED_THE_LEASE = 'You have successfully signed the lease. Keep an eye out for futher messages from us.',
  BREED = 'Breed',
  WEIGHT = 'Weight',
  AGE = 'Age',
  GENDER = 'Gender',
  CAR = 'Car',
  CARS = 'Cars',
  CAR_MAKE = 'Car make',
  MODEL = 'Model',
  YEAR = 'Year',
  LICENSE_PLATE = 'License plate',
  STATE_REGISTRATION = 'State registration',
  COLOR = 'Color',
  SPAYED_OR_NEUTERED = 'My pet is spayed/ neutered',
  SERVICE_ANIMAL = 'My pet is a service animal',
  EMOTIONAL_SUPPORT_ANIMAL = 'My pet is an emotional support animal',
  MM_DD_YYYY = 'MM/DD/YYYY',
  OPERATION_FAILED_PLEASE_TRY_AGAIN_LATER = 'Operation failed, please try again later',
  REMOVE_SELECTED = 'Remove selected',
  PURCHASE_RENTAL_INSURANCE = 'Purchase rental insurance',
  UNAVAILABLE = 'Document Not Found',
  DOCUMENT_NOT_AVAILABLE = 'The document is no longer available. Please contact your property manager for assistance.',
  LINK_EXPIRED_TITLE = 'Link Expired',
  LINK_EXPIRED_MESSAGE = 'This link has expired. Please contact your property manager to request an up-to-date copy of your document.',
  DO_YOU_HAVE_A_PET = 'Do you have a pet?',
  ADD_NEW_PET = 'Add a new pet',
  DO_YOU_HAVE_A_CAR = 'Do you have a car?',
  ADD_NEW_CAR = 'Add a new car',
  NO_UNITS_LISTED = 'Currently, there are no units listed',
  OR_LESS = 'or less',
  OR_MORE = 'or more',
  LIST_SEPARATOR = '{first}, {rest}',
  PRICE_OR_MORE = '{price} or more',
  PRICE_OR_LESS = '{price} or less',
  PRICE_RANGE = '{min}-{max}',
  MIN_BEDS = '{count}+ bd',
  MIN_BATHS = '{count}+ ba',
  MOVE_IN_DATE_FROM = 'Move-in date {date}',
  PETS_ALLOWED_TYPES = 'Allowed ({types})',
  MONTHLY_PET_FEES_AMOUNT = '{amount} Monthly pet fees',
  PET_DEPOSIT_AMOUNT = 'Pet deposit: {amount}',
  ANY_PRICE = 'Any price',
  NO_MORE_RESULTS = 'No more results',
  BY_SUBMITTING_THIS_APPLICATION_BLURB = `By submitting this form, you are giving {companyName} your consent to receive account notifications, and direct communications messages from the company, at the provided number, including messages sent by autodialer. Message frequency may vary. Consent is not a condition of purchase. Message and data rates may apply. Unsubscribe at any time by replying STOP. Reply HELP for help. `,
  SEARCH_UNITS = 'Search units...',
  SEARCH_ADDRESS = 'Search address',
  LANDLORD_EMAIL = 'Landlord email',
  LANDLORD_EMAIL_REQUIRED_FOR_CONSENT = 'Landlord email is required to verify your rental history',
  VERIFICATION_CONSENT = 'I consent to {companyName} contacting this landlord to verify my rental history.',
  SUPPORTING_DOCUMENTS = 'Supporting documents',
  OOPS = 'Oops!',
  APPLICATION_NOT_QUALIFIED_TITLE = 'Application incomplete',
  APPLICATION_NOT_QUALIFIED_BODY = 'Please complete the following before submitting:',
  VALIDATION_FIRST_NAME_REQUIRED = 'First name is required',
  VALIDATION_LAST_NAME_REQUIRED = 'Last name is required',
  VALIDATION_EMAIL_REQUIRED = 'Email is required',
  VALIDATION_PHONE_REQUIRED = 'Phone number is required',
  VALIDATION_SSN_REQUIRED = 'Social Security Number is required',
  VALIDATION_DATE_OF_BIRTH_REQUIRED = 'Date of birth is required',
  VALIDATION_RESIDENTIAL_HISTORY_REQUIRED = 'At least one residential history entry is required',
  VALIDATION_REQUIRED_QUESTIONS_NOT_ANSWERED = 'All required questions must be answered before submitting',
  VALIDATION_ALREADY_SUBMITTED = 'This application has already been submitted',
  VALIDATION_REQUIRED_FILES_MISSING = 'Required documents are missing',
  VALIDATION_TERMS_NOT_ACCEPTED = 'The terms have not been accepted',
  APPLY_NOW = 'Apply now',
  SUMMARY = 'Summary',
  APPLICATION_EDIT_WARNING = 'You will not be able to edit your application after submission. Please review your information carefully before proceeding.',
  APPLICATION_LOCKED_WARNING = 'The application has been submitted and is now locked. No changes to the previously entered data are possible.',
  EDIT = 'Edit',
  CHANGE = 'Change',
  UNIT = 'Unit',
  SPECIAL_INFO = 'Special Info',
  MAKE_AND_MODEL = 'Make & Model',
  EMPLOYMENT = 'Employment',
  EMPLOYMENT_HISTORY_REQUIRED = 'Please add at least one employment record',
  TEXT_TOO_LONG = 'Text has to be less than 500 characters',
  PERMISSION_TO_TEXTING_NOTICE = 'Notice: Leaving this box unchecked may prevent you from receiving important updates about your rental application. If you’re comfortable with this, simply click Next again to continue.',
  COULD_NOT_LOAD_PDF_FILE = 'Could not load PDF file!',
  WATER_AND_SEWER = 'Water & sewer',
  ELECTRICITY = 'Electricity',
  GAS = 'Gas',
  TRASH = 'Trash',
  INTERNET_CABLE = 'Internet/cable',
  HEATING_AIR_CONDITIONING = 'Heating/air conditioning',
  IN_UNIT_WASHER_DRYER = 'In-unit washer/dryer',
  DISHWASHER = 'Dishwasher',
  MICROWAVE = 'Microwave',
  STAINLESS_STEEL_APPLIANCES = 'Stainless steel appliances',
  HARDWOOD_FLOORING = 'Hardwood flooring',
  CENTRAL_AC_HEATING = 'Central AC/heating',
  WALK_IN_CLOSETS = 'Walk-in closets',
  HIGH_SPEED_INTERNET = 'High-speed internet',
  FIREPLACE = 'Fireplace',
  PATIO = 'Patio',
  BBQ_GRILLS_OR_PICNIC_AREA = 'BBQ grills or picnic area',
  ROOFTOP_DECK = 'Rooftop deck',
  PARKING_SPACE = 'Parking space',
  GYM = 'Gym',
  SWIMMING_POOL = 'Swimming pool',
  COMMUNITY_CLUBHOUSE = 'Community clubhouse',
  PLAYGROUND_OR_DOG_PARK = 'Playground or dog park',
  LAUNDRY_FACILITIES = 'Laundry facilities',
  PARKING_OR_GARAGE = 'Parking or garage',
  SECURITY_OR_CONTROLLED_ACCESS = '24/7 security or controlled access',
  E_SIGNATURE_CONSENT_TITLE = 'Electronic Record and Signature Disclosure',
  E_SIGNATURE_CONSENT_BODY = 'By selecting "I Agree", I consent to conduct business electronically, including signing documents using electronic signatures. I acknowledge that I have read and agree to the terms of use for electronic signatures.',
  E_SIGNATURE_CONSENT_AGREE = 'I agree to use electronic records and signatures',
  E_SIGNATURE_CONSENT_ERROR = 'You must agree to the electronic signature terms to continue',
  E_SIGNATURE_DISCLOSURE_LINK = 'Review full Electronic Record and Signature Disclosure',
  START_SIGNING = 'Start signing',
  FILE_KIND_GOVERNMENT_ID = 'Government ID',
  FILE_KIND_BANK_STATEMENT = 'Bank statement',
  FILE_KIND_PAY_STUB = 'Pay stub',
  FILE_KIND_TAX_RETURN = 'Tax return',
  FILE_KIND_OFFER_LETTER = 'Offer letter',
  FILE_KIND_REFERENCE_LETTER = 'Reference letter',
  FILE_KIND_EMPLOYMENT_VERIFICATION = 'Employment verification',
  FILE_KIND_OTHER = 'Other documents',
  UPLOADING_FILE_PROGRESS = 'Uploading {current} of {total}: {fileName}',
  TERMS_ACCEPTED_AT = 'Accepted on {date}',
  VERIFYING_YOUR_IDENTITY = 'Verifying your identity. Please hold on...',
  FETCHING_FROM_TRANSUNION = 'Fetching data from TransUnion',
  LOADING_APPLICATION = 'Loading your application...',
  LOADING_PAYMENT_FINALIZING = 'Waiting for the payment to finalize...',
  LOADING_PAYMENT_INFO = 'Loading payment details...',
  LOADING_TAKING_LONGER = 'This is taking longer than expected. Please contact support if it does not resolve soon.',
  SUBMIT_BLOCKED_MAGICDOOR_TERMS = 'Accept the MagicDoor terms of service to continue.',
  SUBMIT_BLOCKED_TRANSUNION_TERMS = 'Accept the TransUnion terms of service to continue.',
  SUBMIT_BLOCKED_MISSING_REQUIRED_FIELDS = 'Fill in the remaining required fields on your application.',
  SUBMIT_BLOCKED_HEADING = 'Before you can submit:',
  MISSING_REQUIRED_DOCUMENT = 'Upload required document: {name}',
  NUMBERED_ITEM = '{label} {number}',
  UPLOADING_FILE_COUNT = 'Uploading {current} of {total}',
  GENDER_MALE = 'Male',
  GENDER_FEMALE = 'Female',
  APPLICATION_STATUS_DRAFT = 'Draft',
  APPLICATION_STATUS_RETRACTED = 'Retracted',
  JOB_AT_EMPLOYER = '{jobTitle} at {employer}',
  SPAYED_NEUTERED_LABEL = 'Spayed/Neutered',
  SERVICE_ANIMAL_LABEL = 'Service Animal',
  EMOTIONAL_SUPPORT_ANIMAL_LABEL = 'Emotional Support Animal',
  UPLOAD_REQUIRED_DOCUMENTS = 'Required documents',
  INFO_UPDATE_MODE_BADGE = 'Update requested',
  INFO_UPDATE_BADGE_HINT = '{companyName} has asked you to review and update your application.',
  INFO_UPDATE_WELCOME = 'Welcome',
  INFO_UPDATE_WELCOME_TITLE = 'Update your application',
  INFO_UPDATE_WELCOME_BODY = '{companyName} has asked you to review and update parts of your application. Use the menu on the left to edit any section. Your changes are saved as you go. When you are finished, click Done.',
  INFO_UPDATE_WELCOME_GET_STARTED = 'Get started',
  INFO_UPDATE_PERSONAL_INFORMATION = 'Personal information',
  INFO_UPDATE_DONE = 'Done',
  INFO_UPDATE_DONE_PROMPT = 'Finished updating? Click Done to let {companyName} know your changes are ready.',
  INFO_UPDATE_DONE_CONFIRM_TITLE = 'Submit your changes?',
  INFO_UPDATE_DONE_CONFIRM_BODY = 'Once submitted, this update link can no longer be used. {companyName} will need to send a new code if anything else needs changing.',
  INFO_UPDATE_DONE_CONFIRM_OK = 'Submit',
  INFO_UPDATE_DONE_CONFIRM_CANCEL = 'Keep editing',
  INFO_UPDATE_THANK_YOU_TITLE = 'Thanks — your update has been submitted',
  INFO_UPDATE_THANK_YOU_BODY = '{companyName} will review your changes. You can close this window.',
  INFO_UPDATE_ERROR_LOCKED = 'This update link is no longer valid. Please ask {companyName} to send a new one.',
  INFO_UPDATE_ERROR_EXPIRED = 'This update link has expired. Please contact {companyName} for a new one.',
  INFO_UPDATE_ERROR_INVALID = 'This update link is invalid. Please contact {companyName} for help.',
  INFO_UPDATE_ERROR_COMPLETED = 'This update has already been submitted. No further changes are needed.',
  INFO_UPDATE_ERROR_CANCELLED = 'This update link was cancelled by {companyName}. Please contact them if you still need to make changes.',
  INFO_UPDATE_ERROR_UNCERTAIN = "We couldn't confirm whether this link is still active. You can continue editing, but your changes may not save if the link has already been used or expired. Contact your property manager if you need a new link.",
  INFO_UPDATE_REFRESH_TO_VERIFY = 'Refresh to verify',
  LANDLORD_VERIFICATION_TITLE = 'Rental history verification',
  LANDLORD_VERIFICATION_INTRO = 'Please confirm the rental history below for {applicantName}.',
  LANDLORD_VERIFICATION_APPLICANT = 'Applicant',
  LANDLORD_VERIFICATION_ADDRESS = 'Address',
  LANDLORD_VERIFICATION_MOVE_IN = 'Move-in date',
  LANDLORD_VERIFICATION_MOVE_OUT = 'Move-out date',
  LANDLORD_VERIFICATION_RESPONSE = 'Your response',
  LANDLORD_VERIFICATION_VERIFIED = 'Verified',
  LANDLORD_VERIFICATION_DECLINED = 'Declined',
  LANDLORD_VERIFICATION_REJECTED = 'Rejected',
  LANDLORD_VERIFICATION_NOTES = 'Notes (optional)',
  LANDLORD_VERIFICATION_HAD_LATE_PAYMENTS = 'Tenant had late payments',
  LANDLORD_VERIFICATION_WAS_EVICTED = 'Tenant was evicted',
  LANDLORD_VERIFICATION_WOULD_RECOMMEND = 'Would recommend this tenant',
  LANDLORD_VERIFICATION_SUBMIT = 'Submit response',
  LANDLORD_VERIFICATION_SUBMITTING = 'Submitting...',
  LANDLORD_VERIFICATION_THANK_YOU_TITLE = 'Thank you',
  LANDLORD_VERIFICATION_THANK_YOU_BODY = 'Your response has been recorded.',
  LANDLORD_VERIFICATION_ALREADY_COMPLETE_TITLE = 'This verification is already complete',
  LANDLORD_VERIFICATION_ALREADY_COMPLETE_BODY = 'This link has already been used to submit a response.',
  LANDLORD_VERIFICATION_INVALID_LINK_TITLE = 'Link not found',
  LANDLORD_VERIFICATION_INVALID_LINK_BODY = 'This verification link is invalid or has expired.',
  LANDLORD_VERIFICATION_MAGIC_RIBBON = 'Verifying via MagicDoor — the AI-native property management platform used by {companyName}.',
  LANDLORD_VERIFICATION_MAGIC_FOOTER_TITLE = '{companyName} runs on MagicDoor',
  LANDLORD_VERIFICATION_MAGIC_FOOTER_BODY = 'The AI-native property management platform — leasing, maintenance, and accounting in one place. Free for up to 10 leases.',
  LANDLORD_VERIFICATION_MAGIC_LEARN_MORE = 'Learn more',
  LANDLORD_VERIFICATION_MAGIC_THANK_YOU_TITLE = 'Tired of chasing landlord verifications by email?',
  LANDLORD_VERIFICATION_MAGIC_THANK_YOU_BODY = 'MagicDoor automates this — and the rest of property management. AI handles the busywork so you can focus on tenants. Free for your first 10 leases.',
  LANDLORD_VERIFICATION_MAGIC_TRY_FREE = 'Try MagicDoor free',
  LANDLORD_VERIFICATION_VERIFIER_NAME = 'Your name',
  LANDLORD_VERIFICATION_VERIFIER_NAME_HINT = 'Helpful for our records',
  LANDLORD_VERIFICATION_WANTS_MAGICDOOR_INFO = "I'd like to learn more about MagicDoor for my own properties.",
  LANDLORD_VERIFICATION_SUBMITTED_BY = 'Submitted by {verifierName}',
  LANDLORD_VERIFICATION_YOUR_PROPERTY_MANAGER = 'Your property manager',
  LANDLORD_VERIFICATION_RESPONSE_REQUIRED = 'Please choose a response before submitting.',
  INSURANCE_LINK_NOT_FOUND = 'The insurance offer could not be loaded. Please reload the page and try again.',
  CO_APPLICANTS_STEP_LABEL = 'Co-applicants',
  CO_APPLICANTS_TITLE = 'Invite co-applicants',
  CO_APPLICANTS_INTRO = 'If others are renting with you, invite them so each person can fill out their own part of the application. You can skip this and continue.',
  CO_APPLICANTS_LIST_HEADING = 'Already invited',
  CO_APPLICANTS_NONE_INVITED = "You haven't invited anyone yet.",
  CO_APPLICANTS_ADD_HEADING = 'Add a co-applicant',
  CO_APPLICANTS_FIRST_NAME = 'First name',
  CO_APPLICANTS_LAST_NAME = 'Last name',
  CO_APPLICANTS_EMAIL = 'Email',
  CO_APPLICANTS_EMAIL_HINT = 'Required to send the invite',
  CO_APPLICANTS_PHONE = 'Phone',
  CO_APPLICANTS_MESSAGE = 'Personal message (optional)',
  CO_APPLICANTS_SEND_INVITE = 'Send invite',
  CO_APPLICANTS_SENDING = 'Sending...',
  CO_APPLICANTS_INVITE_FAILED = 'Could not send the invite. Please try again.',
  CO_APPLICANTS_NO_EMAIL_NOTE = 'No email — invite will not be sent automatically.',
  SIGNING_OFFERS_DW_TITLE = 'Heads up: damage waiver applies to this lease',
  SIGNING_OFFERS_DW_SUBTITLE = 'Information from your property manager — no action needed right now.',
  SIGNING_OFFERS_DW_NOTE = "Your property manager has enabled the damage waiver program. Since no valid renter's insurance is on file, a waiver charge starts automatically after the grace period. Upload a renter's insurance policy any time to avoid this charge.",
  SIGNING_OFFERS_DW_MONTHLY_FEE = 'Monthly waiver fee',
  SIGNING_OFFERS_DW_BILLING_STARTS = 'Billing starts',
  SIGNING_OFFERS_DW_BILLING_AFTER = 'after {date}',
  SIGNING_OFFERS_DW_STATUS = 'Status',
  SIGNING_OFFERS_DW_ENROLLED = 'Currently enrolled',
  SIGNING_OFFERS_DW_OPTED_OUT_TITLE = 'Damage waiver eligibility',
  SIGNING_OFFERS_DW_OPTED_OUT_BODY = 'You previously opted out of the damage waiver program. You can restore eligibility if you want the program to apply again.',
  SIGNING_OFFERS_DW_RESTORE = 'Restore eligibility',
  SIGNING_OFFERS_DW_RESTORED_TITLE = 'Eligibility restored',
  SIGNING_OFFERS_DW_RESTORED_BODY = 'Your lease can re-enter the damage waiver process when the program next reviews eligibility. This does not mean you are enrolled or covered yet.',
  SIGNING_OFFERS_RBP_TITLE = 'Resident perks, available to you',
  SIGNING_OFFERS_RBP_SUBTITLE = 'Offered by your property manager. Optional — join only if you want the benefits.',
  SIGNING_OFFERS_RBP_PRICE_HINT = 'Price shown at confirmation',
  SIGNING_OFFERS_RBP_JOIN = 'Join',
  SIGNING_OFFERS_RBP_JOINED = 'Joined',
  SIGNING_OFFERS_RBP_FOOTNOTE = 'Monthly billing through your rent account · cancel anytime after the commitment period',
  SIGNING_OFFERS_RBP_NO_THANKS = 'No thanks',
  SIGNING_OFFERS_RBP_CONFIRM_TITLE = 'Join {name}?',
  SIGNING_OFFERS_RBP_JOINED_TITLE = 'Joined {name}',
  SIGNING_OFFERS_RBP_CONFIRM_JOIN = 'Confirm & join',
  SIGNING_OFFERS_RBP_LOADING_QUOTE = 'Loading current terms…',
  SIGNING_OFFERS_RBP_NOT_AVAILABLE = 'Currently not available',
  SIGNING_OFFERS_RBP_MONTHLY_AMOUNT = 'Monthly amount',
  SIGNING_OFFERS_RBP_BENEFITS_START = 'Benefits start',
  SIGNING_OFFERS_RBP_COMMITMENT_ENDS = 'Commitment ends',
  SIGNING_OFFERS_RBP_CHARGED_VIA = 'Charged via',
  SIGNING_OFFERS_RBP_RENT_ACCOUNT = 'Your rent account',
  SIGNING_OFFERS_RBP_LOCK_NOTE = 'First charge happens later — nothing is billed today. This confirmation reflects the current terms when you confirm.',
  SIGNING_OFFERS_PER_MONTH = '{amount} / mo',
  RESIDENT_BENEFIT_REASON_UNAVAILABLE = 'This package is not available right now.',
  RESIDENT_BENEFIT_REASON_LEASE_NOT_ACTIVE = 'This package is only available on an active lease.',
  RESIDENT_BENEFIT_REASON_NO_LONGER_OFFERED = 'This package is no longer offered for your lease.',
  RESIDENT_BENEFIT_REASON_ALREADY_JOINED = 'You have already joined this package.',
  COMPANY_LOGO = 'Company logo',
}
